/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LastExecutionStats } from './lastExecutionStats';
import { ScheduledJobStatusEnum } from './scheduledJobStatusEnum';


export interface ScheduledJob { 
    /**
     * The job name, which corresponds to the name of the @Scheduled method
     */
    name: string;
    status: ScheduledJobStatusEnum;
    /**
     * Whether or not this job should run or not
     */
    disabled: boolean;
    /**
     * The amount of seconds to wait after application startup for this job to run
     */
    initial_delay_seconds: number;
    /**
     * The amount of seconds in between each job run
     */
    interval_seconds: number;
    last_execution_stats?: LastExecutionStats;
    /**
     * The last time the job ran since application startup
     */
    last_execution_time?: Date;
    /**
     * The scheduled next execution time
     */
    next_execution_time?: Date;
}
export namespace ScheduledJob {
}


